import { Box, Skeleton, TableHead } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import ModalInforme from '@/components/Modals/ModalInforme';
import ModalRestaurarInforme from '@/components/Modals/ModalRestaurarInforme';
import React, { Fragment, cloneElement, useEffect, useState } from 'react';
import { informeApi, useImprimirInformeMutation } from '@/redux/api/informeApi';
import { IInforme } from '../../../redux/models/typesInformes';
import { Order, getComparator, stableSort } from '../../../utils/tableUtils';
import { EnumActionsInforme } from '../TableBase/types';
import { TablaInformesHead } from './TablaInformesHead';
import TablaInformesRow, { TablaInformesRowCells } from './TablaInformesRow';
import { TablaInformeToolbar } from './TablaInformesToolbar';
import ModalLiquidarUsuarioInforme from '@/components/Modals/ModalLiquidarUsuarioInformes';
import MyToastShow from '@/components/Layout/MyToast';
import { InformeModes } from '@/components/Informes/InformeComponents/InformeRender';
import { TableVirtuoso, TableComponents } from 'react-virtuoso';
import { IUser } from '@/redux/models';

const VirtuosoTableComponents: TableComponents<any> = {
    Scroller: React.forwardRef<HTMLDivElement>((props, ref) => (
        <TableContainer component={Paper} {...props} ref={ref} />
    )),
    Table: (props: any) => (
        <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
    ),
    TableHead: (props: any) => <TableHead {...props} />,
    TableRow: (props: any) => {
        //@ts-ignore
        const childrenProps = props.children.props
        return <TableRow
            hover
            role="checkbox"
            aria-checked={false}
            tabIndex={-1}
            {...childrenProps}
            {...props} />
    },
    TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
        <TableBody {...props} ref={ref} />
    )),
};



export type hideKeysInforme = (keyof IInforme | 'acciones' | 'selectable' | 'ACTION_SEE_INFORMES' | 'ACTION_REPEDIR' | 'ACTION_LIQUIDAR' | 'ACTION_RESTAURAR' | 'ACTION_EDITAR' | 'USUARIOS')[];

type TablaInformesProps = {
    informes: IInforme[]
    hideColumns?: hideKeysInforme;
    onPageChange: (page: number) => Promise<void>
    totalInformes: number
    rowsPerPage: number
    isLoading?: boolean
    titulo?: string
    onInformeRestaurado?: (informe: IInforme) => void
    virtual?: boolean
    selectedUser?: IUser
}

//TODO: Hacer que el virtual funcione

const TablaInformes = ({ informes, hideColumns = [], totalInformes, rowsPerPage, onPageChange, titulo, isLoading = false, onInformeRestaurado, selectedUser, virtual = false }: TablaInformesProps) => {
    const [order, setOrder] = useState<Order>('desc');
    const [orderBy, setOrderBy] = useState<keyof IInforme>('id');
    const [selectedInformes, setSelectedInformes] = useState<IInforme[]>([]);
    // ver informe
    const [informeToModal, setInformeToModal] = useState<IInforme | null>(null)
    const [isModalOpen, setIsModalOpen] = useState(false);
    // restaurar informe
    const [isModalRestaurar, setIsModalRestaurar] = useState(false)
    // liquidar informes
    const [isModalLiquidar, setIsModalLiquidar] = useState(false)
    //user
    const [user, setUser] = useState<IUser>()


    const [imprimirInforme] = useImprimirInformeMutation();

    const handleMarcarImpreso = (informe: IInforme) => {
        const nuevoEstado = true;
        imprimirInforme({ id: informe.id, printed: nuevoEstado }).unwrap().then((res) => {
            MyToastShow({ message: `${informe.printed ? 'Desm' : 'M'}arcado como impreso`, type: "success" })

        }).catch((err) => {
            MyToastShow({ message: "Error al marcar como impreso", type: "error" })
            console.error(err)
        })
    }



    const [page, setPage] = useState(0);
    const dense = false
    const [obtenerInformePorId, { isLoading: loadingById }] = informeApi.endpoints.obtenerInformePorId.useLazyQuery()

    useEffect(() => {
        setSelectedInformes([])
        selectedUser && setUser(selectedUser)
    }, [selectedUser])

    const handleChangePage = (_event: any, newPage: React.SetStateAction<number>) => {
        onPageChange(newPage as number).then(() => {
            setPage(newPage);
        })
    };

    const handleRequestSort = (
        event: React.MouseEvent<unknown>,
        property: keyof IInforme,
    ) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };


    const handleActionClick = (informe: IInforme, action: EnumActionsInforme) => {
        switch (action) {
            case EnumActionsInforme.VER:
                verInforme(informe)
                break;
            case EnumActionsInforme.RESTAURAR:
                restaurarInforme(informe)
                break;
            default:
                break;
        }


    }

    const handleLiquidarInformes = () => {
        setIsModalLiquidar(true)
    }

    const verInforme = (informe: IInforme) => {
        obtenerInformePorId(informe.id).unwrap().then((data: any) => {
            setInformeToModal(data)
            setIsModalOpen(true)
        }).catch(e => MyToastShow({ message: e?.message || 'Error al obtener informe', type: 'error' }))
    }

    const restaurarInforme = (informe: IInforme) => {
        setInformeToModal(informe)
        setIsModalRestaurar(true)
    }

    const isInformeSelected = (informe: IInforme) => selectedInformes.findIndex((i) => i.id === informe.id) !== -1

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setSelectedInformes(informes);
            return;
        }
        setSelectedInformes([]);
    };


    const handleSelectRow = (informe: IInforme) => {

        //@ts-ignore
        if (user && informe.usuario.id !== user.id) {
            MyToastShow({ message: 'No puedes seleccionar informes de distintos usuarios', type: 'error' })
            return
        }

        if (selectedInformes.length === 0) {
            setUser(informe.usuario)
        }

        if (isInformeSelected(informe)) {
            if (selectedInformes.length === 1) {
                setUser(undefined)
            }

            setSelectedInformes(selectedInformes.filter((i) => i.id !== informe.id))
            return
        }
        setSelectedInformes([...selectedInformes, informe])
    }

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, rowsPerPage - informes.length) : 0;

    const visibleRows = React.useMemo(
        () =>
            stableSort(informes as any[], getComparator<keyof IInforme>(order, orderBy)).slice(
                0,
                rowsPerPage,
            ),
        [order, orderBy, rowsPerPage, informes, selectedInformes],
    );




    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }}>
                {!virtual ? <>

                    <TablaInformeToolbar
                        numSelected={selectedInformes.length}
                        onLiquidarInformes={() => handleLiquidarInformes()}
                    />
                    <TableContainer>
                        <Table
                            sx={{ minWidth: 750 }}
                            aria-labelledby="tableTitle"
                            size={dense ? 'small' : 'medium'}
                        >
                            {!isLoading && (<TablaInformesHead
                                numSelected={selectedInformes.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={informes.length}
                                hideColumns={hideColumns}
                            />)}

                            <TableBody>
                                {visibleRows.map((miInforme, index) => {
                                    const isItemSelected = isInformeSelected(miInforme);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (
                                        isLoading ? <Skeleton sx={{ width: '90%', padding: '15px', margin: '0 auto', display: index > 10 ? 'none' : 'block' }} key={`key${miInforme.id}i${index}`} /> :
                                            <TablaInformesRow
                                                key={`key${miInforme.id}`}
                                                informe={miInforme}
                                                isSelected={isItemSelected}
                                                labelId={labelId}
                                                hideColumns={hideColumns}
                                                onClickAction={handleActionClick}
                                                onClickSelect={handleSelectRow}
                                            />
                                    );
                                })}
                                {emptyRows > 0 && (
                                    <TableRow
                                      
                                        style={{
                                            height: (dense ? 33 : 53) * emptyRows,

                                        }}
                                    >
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        labelRowsPerPage="Filas por página"
                        rowsPerPageOptions={[20]}
                        component="div"
                        count={totalInformes}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                    /> </> :
                    <>

                        <TablaInformeToolbar
                            numSelected={selectedInformes.length}
                            onLiquidarInformes={() => handleLiquidarInformes()}
                        />
                        <TableVirtuoso
                            components={VirtuosoTableComponents}
                            data={informes}

                            fixedHeaderContent={() => {
                                return (
                                    <TablaInformesHead
                                        numSelected={selectedInformes.length}
                                        order={order}
                                        orderBy={orderBy}
                                        onSelectAllClick={handleSelectAllClick}
                                        onRequestSort={handleRequestSort}
                                        rowCount={informes.length}
                                        hideColumns={hideColumns}
                                    />
                                )
                            }}
                            itemContent={(index, informe) => {
                                return (
                                    isLoading ? <Skeleton sx={{ width: '90%', padding: '15px', margin: '0 auto', display: index > 10 ? 'none' : 'block' }} key={`key${informe.id}i${index}`} /> :
                                        <TablaInformesRowCells
                                            key={`key${informe.id}`}
                                            informe={informe}
                                            isSelected={isInformeSelected(informe.id)}
                                            labelId={`enhanced-table-checkbox-${index}`}
                                            hideColumns={hideColumns}
                                            onClickViewInforme={handleActionClick}
                                            onClickSelect={handleSelectRow}
                                        />
                                )
                            }}
                            style={{ minHeight: 750 }}
                            totalCount={totalInformes}
                            overscan={10}
                        />
                    </>}
            </Paper>


            {informeToModal && <ModalInforme
                mode={'admin-view'}
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onPrinted={handleMarcarImpreso}
                informe={informeToModal as IInforme}
                onSubmit={function (informe: IInforme): void {
                    throw new Error('Function not implemented. (Como llegaste acá? mandá foto inmediatamente)');
                }} />
            }
            {informeToModal && (
                <ModalRestaurarInforme
                    open={isModalRestaurar}
                    onCancel={() => setIsModalRestaurar(false)}
                    informe={informeToModal as IInforme}
                    onInformeRestaurado={(informe: IInforme) => {
                        setIsModalRestaurar(false)
                        onInformeRestaurado && onInformeRestaurado(informe)
                    }}
                />)
            }
            {isModalLiquidar && (
                <ModalLiquidarUsuarioInforme
                    open={isModalLiquidar}
                    onCancel={() => setIsModalLiquidar(false)}
                    informes={selectedInformes}
                    onInformesLiquidados={(informes) => {
                        setIsModalLiquidar(false)
                    }} />)
            }

        </Box>
    );
};

export default TablaInformes;